export enum MacroObjectType {
    System = 'System',
    Document = 'Document',
    Distribution = 'Distribution',
    DocumentType = 'DocumentType',
    Partner = 'Partner',
    Contact = 'Contact',
    AlertConfiguration = 'AlertConfiguration',
    ExceptionInstance = 'ExceptionInstance',
    ExceptionType = 'ExceptionType',
    Trigger = 'Trigger',
    InterchangeIn = 'InterchangeIn',
    Report = 'Report',
    MonitorStatus = 'MonitorStatus',
    MFA = 'MFA',
    FailedDocument = 'FailedDocument',
    StatusEvent = 'StatusEvent',
    StakeholderDocument = 'StakeholderDocument',
    StakeholderInterchange = 'StakeholderInterchange',
}
